import { Flexbox } from "@sede-enterprise/shell-ds-react-framework";
import styled from "styled-components";

const StyledFlexbox = styled(Flexbox)`
  margin: 0 auto;
  width: 100%;
  height: 100%;
  text-align: center;
  flex-direction: ${(props) => props.flexDirection};
  align-items: ${(props) => props.alignItems};
  overflow: auto; /* Enable scrolling at container level */
`;

export { StyledFlexbox };
